import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Quote } from "lucide-react";
import api from "@/lib/api";
import { SITE_STATS } from "@/data/siteStats";

const STATS = [
  { key: "modules", value: SITE_STATS.modules },
  { key: "questions", value: `${SITE_STATS.questions}+` },
  { key: "scenarios", value: SITE_STATS.scenarios },
  { key: "labLessons", value: SITE_STATS.labLessons },
];

export default function ProofSection() {
  const { t } = useTranslation();
  const [quotes, setQuotes] = useState([]);
  useEffect(() => { api.get("/testimonials").then(({ data }) => setQuotes(Array.isArray(data) ? data : [])).catch(() => {}); }, []);
  return (
    <section className="border-b border-white/10 bg-[#0B132B]" data-testid="landing-proof">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <dl className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4" data-testid="landing-stats">
          {STATS.map((s) => (
            <div key={s.key} data-testid={`landing-stat-${s.key}`} className="rounded-md border border-white/10 bg-card/60 px-4 py-4 sm:py-5">
              <dd className="font-heading text-3xl sm:text-4xl font-black tracking-tight text-white">{s.value}</dd>
              <dt className="text-xs sm:text-sm text-slate-400 mt-1">{t(`landing.proof.${s.key}`)}</dt>
            </div>
          ))}
        </dl>
        {quotes.length > 0 && (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 mt-6 sm:mt-8 stagger-in" data-testid="landing-testimonials">
            {quotes.slice(0, 6).map((q) => (
              <figure key={q.id} data-testid={`landing-quote-${q.id}`} className="rounded-md border border-white/10 bg-card p-5 flex flex-col">
                <Quote size={18} className="text-primary mb-3 shrink-0" />
                <blockquote className="text-sm text-slate-200 leading-relaxed flex-1">“{q.quote}”</blockquote>
                <figcaption className="mt-4 text-xs text-slate-400"><span className="font-semibold text-slate-200">{q.name}</span>{q.role ? ` · ${q.role}` : ""}</figcaption>
              </figure>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
